export const trackBy = (property: string) => (index: number, item: any) => (property === 'index' ? index : item[property]);
